export default "__VITE_ASSET__Dbrgux5t__"